import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MyAppBar from './components/navbar.jsx'
import MyTabs from './components/tab.jsx'
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import theme from './theme';

class Main extends React.Component {
    render() {
        return (
            <div >
                <MyTabs />
            </div>
        );
    }
}

// ========================================

ReactDOM.render(
    <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Main />
  </ThemeProvider>,
    document.getElementById('root')
);
